<template>
  <div class="px-4 rounded flex flex-col relative">
    <div
      class="py-4 border-b bg-grey-lighter font-medium flex flex-1 flex-row"
    >
      <div class="w-full flex">
        <div class="w-1/7 ml-2">Title</div>
        <div class="w-1/7 ml-2">Holiday Starts</div>
        <div class="w-1/7 ml-2">Holiday Ends</div>
        <div class="w-1/7 ml-2">Full Day Closed?</div>
        <div class="w-1/7 ml-2">Start Time</div>
        <div class="w-1/7 ml-2">End Time</div>
        <div class="w-1/7 flex">
          <div class="w-full text-center">Actions</div>
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <holidays-row
        v-for="(holiday, index) in holidays"
        :key="index"
        :holiday-details="holiday"
        :holiday-length="holidays.length"
        :is-edit="isEdit"
        @deleteRow="deleteHoliday"
        @updateSingleHoliday="updateSingleHoliday"
      />
    </div>

    <pt-button
      v-if="!isEdit"
      class="mt-4"
      variant="primary-outline"
      size="sm"
      @action="addHoliday"
    >
      Add Holiday
    </pt-button>
    <div class="add-edit-schedule-content-spacer" />
  </div>
</template>

<script>
import HolidaysRow from '@components/holidays/list-row.vue';

export default {
  name: 'SchedulesList',
  components: {
    HolidaysRow,
  },
  props: {
    holidaysList: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      index: 1,
      holidays: [
        {
          id: 0,
          name: null,
          start_date: null,
          end_date: null,
          is_full_day_closed: true,
          opening_time: null,
          closing_time: null,
        },
      ],
      date: new Date(),
      disabledDates: {
        to: new Date(),
      },
    };
  },
  watch: {
    holidaysList: {
      handler(newVal, oldVal) {
        if (this.isEdit) {
          this.holidays = this.holidaysList;
        }
        this.updateHolidays(this.holidays);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    addHoliday() {
      this.$sendEvent('RS_AddHolidayRow');
      let holiday = {
        id: this.index,
        start_date: null,
        end_date: null,
        is_full_day_closed: true,
        opening_time: null,
        closing_time: null,
      };
      this.holidays.push(holiday);
      this.index++;
      this.updateHolidays();
    },
    deleteHoliday(index) {
      this.holidays = this.holidays.filter(element => element.id !== index);
      this.$emit('deleteHoliday', index);
    },
    updateSingleHoliday(holiday) {
      this.holidays = this.holidays.map(element => element.id === holiday.id ? holiday : element);
      this.updateHolidays();
    },
    updateHolidays() {
      this.$emit('updateHolidays', this.holidays);
    },
  },
};
</script>
